import { render, staticRenderFns } from "./ImportarProcesso.vue?vue&type=template&id=e2dd7a36&scoped=true"
import script from "./ImportarProcesso.vue?vue&type=script&lang=js"
export * from "./ImportarProcesso.vue?vue&type=script&lang=js"
import style0 from "./ImportarProcesso.vue?vue&type=style&index=0&id=e2dd7a36&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2dd7a36",
  null
  
)

export default component.exports